import { render, staticRenderFns } from "./PresetsPanel.vue?vue&type=template&id=3576c6c8&"
import script from "./PresetsPanel.vue?vue&type=script&lang=ts&"
export * from "./PresetsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PresetsPanel.vue?vue&type=style&index=0&id=3576c6c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports